import { connect } from 'react-redux';
import { SubscriptionService } from './SubscriptionService';
import { ISubscriptionServiceStateProps, ISubscriptionServiceDispatchProps, ISubscriptionServiceProps } from './types';
import { IAppState } from '../../../../redux';
import { selectPublishTermsService } from '../../../../redux/reducers';
import { trackServiceClick, trackUnavailableServiceClick } from '../CommonService/CommonService.tracking';
import { getDescription, getTitle } from './utils';
import {
  selectActiveRecommendedPackageByServiceId,
  selectActiveServiceId,
  selectServiceById,
} from '../../../../selectors/publishTerms';
import { selectIsNewOffer } from '../../../../selectors/offer';

export const mapStateToProps = (state: IAppState): ISubscriptionServiceStateProps => {
  const serviceId = 'servicePackage';

  const isNewOffer = selectIsNewOffer(state);
  const currentService = selectServiceById(serviceId, state);
  const selectedPackage = selectActiveRecommendedPackageByServiceId(serviceId, state);
  const selectedServiceId = selectActiveServiceId(state);

  const isActive = serviceId === selectedServiceId;

  return {
    isNewOffer,
    isActive,
    service: currentService,
    selectedPackage,
  };
};

export const mapDispatchToProps = {
  selectPublishTermsService,
};

export const mergeProps = (
  stateProps: ISubscriptionServiceStateProps,
  dispatchProps: ISubscriptionServiceDispatchProps,
): ISubscriptionServiceProps => {
  const { isNewOffer, service, isActive, selectedPackage } = stateProps;
  const { selectPublishTermsService } = dispatchProps;
  const { id, isAvailable, name } = service;

  const handleCardClick = () => {
    if (isActive) {
      return;
    }

    if (isAvailable) {
      selectPublishTermsService(id);
      trackServiceClick(id, isNewOffer);
    } else {
      trackUnavailableServiceClick(id, isNewOffer);
    }
  };

  if (!selectedPackage) {
    return {
      name,
      isActive,
      handleCardClick,
      title: null,
      description: null,
      discount: null,
    };
  }

  return {
    name,
    isActive,
    handleCardClick,
    title: getTitle(selectedPackage),
    description: getDescription(selectedPackage),
    discount: selectedPackage.discount,
  };
};

export const SubscriptionServiceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SubscriptionService);
